export default "__VITE_ASSET__d4971bf4__"